import {
  COMMON,
  type CommonProps,
  type FlexProps,
  type LayoutProps,
} from '#app/theme/constants.js';
import { FLEX, LAYOUT } from '#app/theme/index.js';
import { sx, type SXProps } from '#app/theme/utils.js';
import { css, styled } from 'styled-components';

export type StyledTextFieldInputProps = CommonProps &
  FlexProps &
  LayoutProps &
  SXProps & {
    readonly variant?: 'default' | 'tall';
  };

export const StyledTextFieldInput = styled.input<StyledTextFieldInputProps>`
  ${({ theme, variant }) => css`
    flex: 1;
    width: 100%;
    padding: 0 4px;
    margin: 0;
    height: ${variant === 'tall' ? '54px' : '38px'};
    outline: none;
    border: 0;
    background-color: transparent;
    border-radius: inherit;
    color: ${theme.colorsV2.black};

    &:disabled {
      background: none;
      color: ${theme.colorsV2.gray40};

      &::placeholder {
        color: ${theme.colorsV2.gray40};
      }
    }

    &:focus {
      /* This is required because of the CSS reset */
      margin-left: 0;
      margin-right: 0;
      padding-left: 4px;
      padding-right: 4px;
    }

    &:first-child,
    &:first-child:focus {
      padding-left: 16px;
      margin-left: 0;
    }

    &:last-child,
    &:last-child:focus {
      padding-right: 16px;
      margin-right: 0;
    }

    &::placeholder {
      opacity: 1;
      color: ${theme.colorsV2.gray60};
    }

    ${COMMON}
    ${FLEX}
    ${LAYOUT}
    ${sx}
  `}
`;
